/** @flow */
// don't remove dotsm because it'll break the help:me script.
import getCurrent from '../../../utils/URL/getCurrent';
import getURL from '../../../utils/URL/getURL';
import {
  SecretsManagerClient,
  GetSecretValueCommand,
} from "@aws-sdk/client-secrets-manager";

let NO_CODE;

const DEFAULT_URL = 'http://127.0.0.1:3001';

const PRICING_UPDATE_URL = "https://pricing.dev.propstream.com";

const CAMPAIGN_BASE_URL = "https://campaign.propstream.com";

const BATCHDIALER_POSTBACK_URL = "https://api.batchdialer.propstream.com";

const getFormattedUrl = (base) => {
  if (process.env.NODE_ENV !== 'dev-server') {
    return base || DEFAULT_URL;
  }

  const current = getCurrent();

  if (!base) {
    current.pathname = '';
  }
  const url = getURL(
    (((base) || DEFAULT_URL)),
  );
  url.protocol = current.protocol;
  url.hostname = current.hostname;

  if (current.port) {
    url.port = current.port;
  }

  return url.href;
};

const getBaseUrl = () => {
  if (process.env.API_BASE_URL === 'NO_BASE_URL') return DEFAULT_URL;
  return getFormattedUrl(process.env.API_BASE_URL);
};

const getCancelationBaseUrl = () => {
  if (process.env.CANCELATION_BASE_URL === 'NO_BASE_URL') return DEFAULT_URL;
  return process.env.CANCELATION_BASE_URL;
};
const getAduCalculatorBaseUrl = () => {
  if (process.env.ADU_CALCULATOR_BASE_URL === 'NO_BASE_URL') return DEFAULT_URL;
  return process.env.ADU_CALCULATOR_BASE_URL;
};

const getDemographicsUrl = () => {
  if (process.env.DEMOGRAPHICS_URL === 'NO_BASE_URL') return DEFAULT_URL;
  return process.env.DEMOGRAPHICS_URL;
};

// propstream-core gateway, fronting the newer core services (investor-service
// first). Deliberately NOT routed through the EXTRA_URL dev proxy: that would
// prepend a temp routing prefix to the path. This stays an absolute URL, so the
// browser calls the gateway directly — which means the gateway's CORS
// allowedOrigins must include the dev origin.
const getPsCoreBaseUrl = () => {
  if (process.env.PS_CORE_BASE_URL === 'NO_BASE_URL') return DEFAULT_URL;
  return process.env.PS_CORE_BASE_URL || DEFAULT_URL;
};

const getGoogleAnalytics = () => {
  return process.env.GOOGLE_ANALYTICS;
};

const getIntelligenceUrl = () => {
  return process.env.INTELLIGENCE_URL;
};

const getPricingUpdateUrl = () => {
  return process.env.PRICING_UPDATE_URL || PRICING_UPDATE_URL;
};

const getBatchDialerUrl = () => {
  return process.env.BATCHDIALER_BASE_URL;
};

const getCampaignBaseUrl = () => {
  return process.env.CAMPAIGN_BASE_URL || CAMPAIGN_BASE_URL;
};

const getBatchDialerPostbackUrl = () => {
  return process.env.BATCHDIALER_POSTBACK_URL || BATCHDIALER_POSTBACK_URL;
};

const getBallpointAPIBaseUrl = () => {
  return process.env.BALLPOINT_API_BASE_URL;
};

const getBallpointIFrameUrl = () => {
  return process.env.BALLPOINT_IFRAME_URL;
};

export const BATCHDIALER_BASE_URL = process.env.BATCHDIALER_BASE_URL;
export const BALLPOINT_API_BASE_URL = process.env.BALLPOINT_API_BASE_URL;
export const BALLPOINT_IFRAME_URL = process.env.BALLPOINT_IFRAME_URL;
export const CANCELATION_BASE_URL = process.env.CANCELATION_BASE_URL;
export const GOOGLE_ANALYTICS = process.env.GOOGLE_ANALYTICS;

const getExtraUrl = () => Object.keys(process.env)
  .filter(key => key.startsWith('EXTRA_URL_'))
  .reduce((result, key) => {
    const nextKey = key.replace('EXTRA_URL_', '');
    return {
      ...result,
      [nextKey]: getFormattedUrl(process.env[key]).replace(/\/$/, ''),
    };
  }, {});

const retrieveSecrets = async () => {
  let client = new SecretsManagerClient({
    region: '',
  });
  let secrets;
  try {
    secrets = await client.send(
      new GetSecretValueCommand({
        SecretId: '',
        VersionStage: "AWSCURRENT",
      })
    );
    return JSON.parse(secrets.SecretString);
  } catch (error) {
    throw error;
  }
}

export default {
  BASE_URL: getBaseUrl(),
  CANCELATION_BASE_URL: getCancelationBaseUrl(),
  ADU_CALCULATOR_BASE_URL: getAduCalculatorBaseUrl(),
  DEMOGRAPHICS_URL: getDemographicsUrl(),
  PS_CORE_BASE_URL: getPsCoreBaseUrl(),
  GOOGLE_ANALYTICS: getGoogleAnalytics(),
  INTELLIGENCE_URL: getIntelligenceUrl(),
  PRICING_UPDATE_URL: getPricingUpdateUrl(),
  CAMPAIGN_BASE_URL: getCampaignBaseUrl(),
  BATCHDIALER_BASE_URL: getBatchDialerUrl(),
  BATCHDIALER_POSTBACK_URL: getBatchDialerPostbackUrl(),
  BALLPOINT_API_BASE_URL: getBallpointAPIBaseUrl(),
  BALLPOINT_IFRAME_URL: getBallpointIFrameUrl(),
  EXTRA_URL: getExtraUrl(),
  CODE: {
    SUCCESS: [
      'success',
      null,
      NO_CODE,
    ],
    ERROR: [
      'validation_error',
    ],
    VALIDATION_ERROR: 'validation_error',
  },
  FIELD: {
    VALIDATION_ERRORS: 'validationErrors',
    VALIDATION_DETAILS: 'detail',
  },
};
